import { render, staticRenderFns } from "./PanelEditor.vue?vue&type=template&id=147fa958&scoped=true"
import script from "./PanelEditor.vue?vue&type=script&lang=js"
export * from "./PanelEditor.vue?vue&type=script&lang=js"
import style0 from "./PanelEditor.vue?vue&type=style&index=0&id=147fa958&prod&lang=scss&scoped=true"
import style1 from "./PanelEditor.vue?vue&type=style&index=1&id=147fa958&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147fa958",
  null
  
)

export default component.exports